// @flow

const INLINE_MANUAL_TIMEOUT = 1500;

/* eslint-disable */
export const initializeInlineManual = (config: Object, userDetails: Object): void => {
  const { INLINE_MANUAL_KEY } = config;

  !(function () {
    let e = document.createElement('script'),
      t = document.getElementsByTagName('script')[ 0 ];

    e.async = 1,
      e.src = `https://inlinemanual.com/embed/player.${INLINE_MANUAL_KEY}.bare.js`,
      e.charset = 'UTF-8', t.parentNode.insertBefore(e, t);
  }());

  //  set timeout because otherwise #createInlineManualPlayer is not defined yet
  setTimeout(() => {
      window.inlineManualTracking = {
        uid: userDetails.userId,
        email: userDetails.primaryEmailAddress,
        name: `${userDetails.firstName} ${userDetails.lastName}`,
      };

      createInlineManualPlayer(window.inlineManualPlayerData);
    }, INLINE_MANUAL_TIMEOUT
  );
};

export const updateInlineManualPlayer = (): void => {
  const { inline_manual_player } = window;

  if (inline_manual_player) {
    inline_manual_player.update();
  }
};
/* eslint-enable */
